/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  branch Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_EXPENSE(state, expense) {
    state.expenses.unshift(expense);
    state.totalDataRow++;
  },
  SET_EXPENSES(state, res) {
    state.expenses = res.page.items
    state.totalDataRow = res.page.totalCount;
    state.totalAmount = res.totalAmount;
    state.pageTotalAmount = res.pageTotalAmount;
  },
  UPDATE_EXPENSE(state, expense) {
    let productIndex = state.expenses.findIndex((p) => p.id == expense.id);
    Object.assign(state.expenses[productIndex], expense)
  },
  REMOVE_EXPENSE(state, expenseId) {
    let expenseIndex = state.expenses.findIndex((p) => p.id == expenseId)
    state.expenses.splice(expenseIndex, 1)
  },
}
